import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ty from "../Assets/newty.jpg";
import { Link, useLocation } from "react-router-dom";
import { verifyPackagePaymentOrder } from "../Common/apis";
import Loader from "../Common/Loader.jsx";

function Thankyou() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  console.log(error)

  const verifyPayment = async () => {
    const query = new URLSearchParams(location.search);
    const paymentId = query.get("ref");
    if (!paymentId) {
      setLoading(false);
      setError("Payment verification failed. Please try again.");
      return;
    }
    try {
      setLoading(true);
      const response = await verifyPackagePaymentOrder({ order_id: paymentId });
      console.log("Payment confirmed:", response);
      const status = response.status._embedded
        ? response.status._embedded.payment[0].state
        : "failed";
      if (
        status === "AUTHORISED" ||
        status === "CAPTURED" ||
        status === "PURCHASED"
      ) {
        setError(null);
        console.log("Payment successful");
      } else {
        setError("Payment verification failed. Please try again.");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error confirming payment:", error);
      setError("Payment verification failed. Please try again.");
      setLoading(false);
    }
  };

  useEffect(() => {
    verifyPayment();
  }, []);

  return (
    <>
      <Navbar />
      <div className="thanqq">
        {loading ? (
          <Loader />
        ) : (
          <>
            {error ? (
              <p className="error-message" style={{ color: "red" }}>{error}</p>
            ) : (
              // <p>
                <img src={ty} alt="Thank You" />
                // {/* Lorem Ipsum is simply dummy text of the printing and typesetting
                // industry. */}
              // </p>
            )}
            <br />
            <Link to="/bookclasses">
              <button>View Subscription</button>
            </Link>
          </>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Thankyou;
